import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { TaskAPI, Task as TaskApi } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { saveTasks, createTaskSuccess } from 'data/tasks/slice';
import { addTaskToSpaceTab, updateSpaceTabTaskList } from '..';
import {
  createTaskFromSpaceTabSagaAction,
  CreateTaskPayload,
} from '../actions';

function* createTaskFromSpaceTabSaga({
  payload,
}: PayloadAction<CreateTaskPayload>) {
  const { projectId, spaceTabId, task } = payload;
  const { taskId, ...rest } = task;

  const taskData = { ...task, project: { projectId } } as unknown as TaskApi;

  yield put(saveTasks({ data: [taskData], fetchStatus: FetchStatus.Partial }));

  if (taskId) {
    yield put(addTaskToSpaceTab({ spaceTabId, taskId }));
    const response = (yield TaskAPI.createTask(projectId, rest)) as TaskApi;

    yield put(
      createTaskSuccess({ task: response, projectId, tempTaskId: taskId }),
    );
    yield put(
      updateSpaceTabTaskList({
        spaceTabId,
        taskId: response.taskId,
        tempTaskId: taskId,
      }),
    );
  }
}

export function* watchCreateTaskFromSpaceTabSaga(): Generator {
  yield takeLatest(
    createTaskFromSpaceTabSagaAction.type,
    createTaskFromSpaceTabSaga,
  );
}
